import Nav from "./nav"
import Search from "./search"
import Sliders from "./sliders"
import SpaCards from "./spa-cards"
import SpaGallery from "./spa-gallery"
import SpaDocuments from "./spa-documents"
import Form from "./form"
import Datepicker from "./datepicker"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Sliders(jQuery)
    Datepicker(jQuery)
    SpaCards(jQuery)
    SpaGallery(jQuery)
    Form(jQuery)
    SpaDocuments(jQuery)
})
